import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { downloadF } from "../PDF/PDFDownload";
import endpoint from "../../config/endpoints";
import { noInternetMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class SubCategoryWise extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: "",
    };
  }

  onSearch = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  generateExcel = () => {
    const { fromDate, toDate, showLoador, showNotification } = this.props;

    if (navigator.onLine) {

      let dateJson = {
        fromDate: fromDate,
        toDate: toDate,
      }

      showLoador({ loador: true });
      downloadF({
        isGet: false,
        url:
          endpoint.reportForExcelReports + "/sales-team-wise-sub-category-report-excel-new-format",
        postBody: dateJson,
        ext: "xlsx",
        openNewTab: true,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }

  }

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;

    if (!searchData || searchData.length === 0) {
      return [];
    }
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        currentRow["name"] &&
        currentRow["name"]
          .toString()
          .toLowerCase()
          .includes(searchValue.trim().toLowerCase())
      ) {
        isValid = true;
        return true;
      }
    });
  };

  render() {
    const { subCatListWithValue, subCatList } = this.props;

    return (
      <>
        <LandingScreenHeader
          screenTitle={""}
          showSearchBox={true}
          showTable={true}
          showFilter={false}
          showPdfDownload={false}
          showExcelDownload={true}
          generateExcel={this.generateExcel}
          onSearch={this.onSearch}
        />
        <TableContainer>
          <Table aria-label="simple table" size="medium">
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  style={{ minWidth: "30px" }}
                ></TableCell>
                <TableCell
                  align="center"
                  style={{ minWidth: "70px" }}
                ></TableCell>
                {subCatList.map((dataObj) => {
                  return (
                    <>
                      {" "}
                      <TableCell
                        align="center"
                        style={{ minWidth: "150px" }}
                        colspan={dataObj.subCategory.length}
                      >
                        {dataObj.name}
                      </TableCell>{" "}
                    </>
                  );
                })}
                <TableCell align="center" style={{ minWidth: "70px" }}>
                  Total
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="center" style={{ minWidth: "60px" }}>
                  Sr. No.
                </TableCell>
                <TableCell align="center" style={{ minWidth: "150px" }}>
                  Sales Team
                </TableCell>
                {subCatList.map((dataObj) => {
                  return (
                    <>
                      {dataObj.subCategory.map((subCategoryObject) => {
                        return (
                          <>
                            <TableCell
                              align="center"
                              style={{ minWidth: "150px" }}
                            >
                              {subCategoryObject.subCatName}
                            </TableCell>
                          </>
                        );
                      })}
                    </>
                  );
                })}
                <TableCell align="center" style={{ minWidth: "150px" }}>
                  Total
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.getFilteredTableData(subCatListWithValue).map((salesPersonObject, index) => {
                return (
                  <>
                    <TableRow key={salesPersonObject.index}>
                      <TableCell align="center" component="td" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{ minWidth: "100px" }}
                        component="td"
                        scope="row"
                      >
                        {salesPersonObject.name}
                      </TableCell>
                      {salesPersonObject.categoryList.map((categoryObject) => {
                        return (
                          <>
                            {categoryObject.subCategory.map((subCatObject) => {
                              return (
                                <>
                                  <TableCell
                                    align="right"
                                    style={{ minWidth: "150px" }}
                                  >
                                    {subCatObject.totalAmt.toFixed(2)}
                                  </TableCell>
                                </>
                              );
                            })}
                          </>
                        );
                      })}
                      <TableCell
                        align="right"
                        component="td"
                        scope="row"
                        style={{ minWidth: "150px" }}
                      >
                        {salesPersonObject.grandTotalAmt.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(SubCategoryWise);
